
import './Footer.css';

function Footer() {
  return (
    <div className="footer">
          <div className='footer-dividline'></div>
          <div className='footer-content'>
              <div className='footer-content-copyright-content'>Copyright © 2021 ycylink.com All Rights Reserved 成都辉码科技有限公司</div>
              <div className='footer-content-dividline'></div>
              <div className='footer-content-copyright'></div>
              <div className='footer-content-copyright-link' onClick={() => { window.open('https://beian.miit.gov.cn/')}}>蜀ICP备2021030029号</div>
              <div className='footer-content-dividline'></div>
              <div className='footer-content-copyright-link' onClick={() => { window.open('http://os.ycylink.com/')}}>一处云混跑镜像</div>
          </div>
     </div>
  );
}

export default Footer;
